import { createSelector } from '@ngrx/store';
import { SedEventsState } from '../reducers/sed-events.reducer';
import { DiscussionsState } from '../reducers/discussion.reducer';

export const selectDiscussionsState = (state: any) => state.discussions;

export const selectDiscussions = createSelector(
  selectDiscussionsState,
  (state: DiscussionsState) => state.discussion
);

export const selectAllDiscussions = createSelector(
  selectDiscussionsState,
  (state: DiscussionsState) => state.discussion?.messages
);
